import {useSelector} from 'react-redux'
import {getIsOfferSoldOut} from 'modules/accommodation/selectors'

import {Offer} from '@daedalus/core/src/offer/types/offer'
import {SplitBooking} from '@daedalus/core/src/room/types/room'

export const useGetIsOfferSoldOut = ({
  offer,
  splitBooking
}: {
  offer?: Offer
  splitBooking?: SplitBooking
}) => {
  const id = offer?.id || splitBooking?.bundleId

  const isSoldOut = useSelector(state => getIsOfferSoldOut(state, id))

  return isSoldOut
}
